import { CanDeactivateFn } from '@angular/router';
import type { DetalleContenidoComponent } from '../pages/detalle-contenido/detalle-contenido.component';

export const meduCanDeactivateGuard: CanDeactivateFn<DetalleContenidoComponent> = component => {
  return component.prepararSalidaMedu();
};
